export class ComplianceStatusFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<ComplianceStatus>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<ComplianceStatus>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ComplianceStatusFilters.attributeTypeMap;
    }
    constructor() {
    }
}
